import { AdminPageContent } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { ScopesTable } from "./components/ScopesTable";

const AdminScopes = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Scopes");

    useMountEffect(() => {
        setBreadcrumbs([{ label: "Admin", path: "home" }, { label: "Scopes" }]);
    });

    return (
        <AdminPageContent>
            <ScopesTable />
        </AdminPageContent>
    );
};

export default AdminScopes;
